import { Space } from 'antd';
import classNames from 'classnames';
import { useMemo } from 'react';
import { CustomBadgeProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle, getCSSVariable } from '../../utils';
import { CustomBadgeWrapper } from './styles';

const CustomBadge: React.FC<CustomBadgeProps> = props => {
  const {
    width,
    height,
    prefix,
    suffix,
    onClick,
    children,
    className,
    fullWidth,
    style = {},
    color = 'dark',
    size = 'middle',
    primary = false,
    ...rest
  } = props;

  const newColor = useMemo(() => {
    switch (color) {
      case 'dark':
        return getCSSVariable('--secondary');
      case 'primary':
        return getCSSVariable('--primary');
      case 'linkage':
        return getCSSVariable('--link');
      case 'success':
        return getCSSVariable('--success');
      case 'error':
        return getCSSVariable('--error');
      case 'warn':
        return getCSSVariable('--warn');
      default:
        return color;
    }
  }, [color]);

  const newStyle = useMemo(() => {
    return {
      ...style,
      ...createNewWidthHeightStyle({ width, height }),
      cursor: !!onClick ? 'pointer' : 'unset',
    };
  }, [width, height, style, onClick]);

  const Prefix = () => <div className="prefix">{prefix}</div>;
  const Suffix = () => <div className="suffix">{suffix}</div>;

  return (
    <CustomBadgeWrapper
      {...rest}
      style={newStyle}
      onClick={onClick}
      className={classNames(className, size, color, {
        'primary-type': primary,
        fullWidth,
      })}
      background={newColor}
    >
      <Space size={size === 'small' ? [4, 0] : [8, 0]}>
        {prefix && <Prefix />}
        {children}

        {suffix && <Suffix />}
      </Space>
    </CustomBadgeWrapper>
  );
};

export default CustomBadge;
